export const pluralize = (count: number, singular: string, plural?: string) => {
  if (!plural) plural = `${singular}s`;
  return count === 0 || count > 1 ? plural : singular;
};
